import script from "./reportscomponent.vue?vue&type=script&setup=true&lang=js"
export * from "./reportscomponent.vue?vue&type=script&setup=true&lang=js"

import "./reportscomponent.vue?vue&type=style&index=0&id=9a0da090&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a0da090"]])

export default __exports__